import { isNativeNotWeb, isIosNativeOnly, isAndroidNativeOnly } from '@/utils/platform-check';

export default {
  computed: {
    isNativeNotWeb() {
      return isNativeNotWeb();
    },
    isIos() {
      return isIosNativeOnly();
    },
    isAndroid() {
      return isAndroidNativeOnly();
    },
  },
};
